import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Link } from '@snack-uikit/link';
import { CONTROL } from '../../../../components';
import { generateCpuItems, generateRamItems, getDisk } from '../../../utils';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var MrsSpecificationItem = {
  GeneralPurpose: 'General-Purpose (ECS)',
  DedicatedGeneralPurpose: 'Dedicated General-Purpose (ECS)',
  MemoryOptimized: 'Memory-optimized (ECS)',
  DiskIntensive: 'Disk-intensive (ECS)'
};
var mrsSpecificationItems = [{
  label: 'General-Purpose',
  value: MrsSpecificationItem.GeneralPurpose,
  description: /*#__PURE__*/_jsxs("span", {
    children: ["\u0411\u0430\u0437\u043E\u0432\u044B\u0439 \u0441\u0435\u0440\u0432\u0435\u0440, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0438\u0432\u0430\u0435\u0442 \u0440\u0430\u0431\u043E\u0442\u0443 \u0432\u0438\u0440\u0442\u0443\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u043E\u0440\u0430 (vCPU), \u043F\u0430\u043C\u044F\u0442\u0438, \u0441\u0435\u0442\u0438. \u041F\u043E\u0434\u0445\u043E\u0434\u0438\u0442 \u0434\u043B\u044F \u0431\u0430\u0437\u043E\u0432\u044B\u0445 \u0432\u044B\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u0439, \u043D\u0435 \u0442\u0440\u0435\u0431\u0443\u044E\u0449\u0438\u0445 \u0432\u044B\u0441\u043E\u043A\u043E\u0439 \u043D\u0430\u0433\u0440\u0443\u0437\u043A\u0438.", ' ', /*#__PURE__*/_jsx(Link, {
      onClick: function onClick(event) {
        return event.stopPropagation();
      },
      href: "https://cloud.ru/docs/ecs/ug/topics/glossary.html#term-2",
      target: "_blank",
      textMode: "accent",
      insideText: true,
      size: "m",
      text: "\u041A\u043E\u044D\u0444\u0444\u0438\u0446\u0438\u0435\u043D\u0442 \u043F\u0435\u0440\u0435\u043F\u043E\u0434\u043F\u0438\u0441\u043A\u0438 \u043D\u0430 \u044F\u0434\u0440\u0430"
    }), ' ', "1:3."]
  })
}, {
  label: 'Dedicated General-Purpose',
  value: MrsSpecificationItem.DedicatedGeneralPurpose,
  description: /*#__PURE__*/_jsxs("span", {
    children: ["\u041F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u0432\u044B\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0435 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u043E\u0440\u044B \u0438 \u043F\u0430\u043C\u044F\u0442\u044C. \u041F\u043E\u0434\u0445\u043E\u0434\u0438\u0442 \u0434\u043B\u044F \u0441\u0435\u0440\u0432\u0438\u0441\u043E\u0432 \u0438 \u043C\u0430\u043B\u043E\u043C\u0430\u0441\u0448\u0442\u0430\u0431\u043D\u044B\u0445 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0439 \u0431\u0430\u0437 \u0434\u0430\u043D\u043D\u044B\u0445 \u0441 \u0432\u044B\u0441\u043E\u043A\u0438\u043C\u0438 \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u044F\u043C\u0438 \u043A \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u043E\u0440\u0430 \u0438 \u043F\u0430\u043C\u044F\u0442\u0438. \u041D\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442", ' ', /*#__PURE__*/_jsx(Link, {
      onClick: function onClick(event) {
        return event.stopPropagation();
      },
      href: "https://cloud.ru/docs/ecs/ug/topics/glossary.html#term-2",
      target: "_blank",
      textMode: "accent",
      insideText: true,
      size: "m",
      text: "\u043F\u0435\u0440\u0435\u043F\u043E\u0434\u043F\u0438\u0441\u043A\u0443 \u043D\u0430 \u044F\u0434\u0440\u0430"
    }), "."]
  })
}, {
  label: 'Memory-optimized',
  value: MrsSpecificationItem.MemoryOptimized,
  description: 'Развернут на платформе виртуализации последнего поколения. Обеспечивает высокоэффективный доступ к памяти. Не использует переподписку на ядра.'
}, {
  label: 'Disk-intensive',
  value: MrsSpecificationItem.DiskIntensive,
  description: 'Disk-intensive Развернут на платформе виртуализации последнего поколения. Обеспечивает высокую пропускную способность хранилища. Не использует переподписку на ядра.'
}];
var specificationToCpuMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, MrsSpecificationItem.GeneralPurpose, [16]), MrsSpecificationItem.DedicatedGeneralPurpose, [16, 32, 64]), MrsSpecificationItem.MemoryOptimized, [8, 16, 32, 64]), MrsSpecificationItem.DiskIntensive, [16, 24, 32, 48, 64, 72]);
var specificationCpuToRamMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, MrsSpecificationItem.GeneralPurpose, {
  '16': [64]
}), MrsSpecificationItem.DedicatedGeneralPurpose, {
  '16': [32, 64],
  '32': [64, 128],
  '64': [128, 256]
}), MrsSpecificationItem.MemoryOptimized, {
  '8': [64],
  '16': [128],
  '32': [256],
  '64': [512]
}), MrsSpecificationItem.DiskIntensive, {
  '16': [64],
  '24': [96],
  '32': [128],
  '48': [192],
  '64': [256],
  '72': [288]
});
function getNodeConfig(prefix) {
  var accessorKey = {
    cpu: "".concat(prefix, ".mrs.cpu"),
    specification: "".concat(prefix, ".mrs.specification"),
    ram: "".concat(prefix, ".mrs.ram")
  };
  return {
    specification: {
      type: CONTROL.Carousel,
      defaultValue: MrsSpecificationItem.GeneralPurpose,
      accessorKey: accessorKey.specification,
      items: mrsSpecificationItems,
      decoratorProps: {
        label: 'Тип сервера'
      },
      onChangeFn: function onChangeFn(value, setValue) {
        var arr = [[accessorKey.specification, value]];
        switch (value) {
          case MrsSpecificationItem.DedicatedGeneralPurpose:
            {
              arr.push([accessorKey.cpu, '16']);
              arr.push([accessorKey.ram, '32']);
              break;
            }
          case MrsSpecificationItem.MemoryOptimized:
            {
              arr.push([accessorKey.cpu, '8']);
              arr.push([accessorKey.ram, '64']);
              break;
            }
          case MrsSpecificationItem.DiskIntensive:
          case MrsSpecificationItem.GeneralPurpose:
          default:
            {
              arr.push([accessorKey.cpu, '16']);
              arr.push([accessorKey.ram, '64']);
              break;
            }
        }
        setValue(arr);
      }
    },
    cpu: {
      type: CONTROL.Segmented,
      accessorKey: "".concat(prefix, ".mrs.cpu"),
      defaultValue: '16',
      items: generateCpuItems([16]),
      decoratorProps: {
        label: 'Количество vCPU'
      },
      watchedControls: {
        specification: "".concat(prefix, ".mrs.specification")
      },
      relateFn: function relateFn(_ref) {
        var specification = _ref.specification;
        var items = specificationToCpuMap === null || specificationToCpuMap === void 0 ? void 0 : specificationToCpuMap[specification];
        if ((items === null || items === void 0 ? void 0 : items.length) > 0) {
          return {
            items: generateCpuItems(items)
          };
        }
      }
    },
    ram: {
      type: CONTROL.Segmented,
      accessorKey: "".concat(prefix, ".mrs.ram"),
      defaultValue: '64',
      items: generateRamItems([64]),
      decoratorProps: {
        label: 'Объём RAM'
      },
      watchedControls: {
        specification: "".concat(prefix, ".mrs.specification"),
        cpu: "".concat(prefix, ".mrs.cpu")
      },
      relateFn: function relateFn(_ref2) {
        var _specificationCpuToRa2;
        var specification = _ref2.specification,
          cpu = _ref2.cpu;
        var items = specificationCpuToRamMap === null || specificationCpuToRamMap === void 0 ? void 0 : (_specificationCpuToRa2 = specificationCpuToRamMap[specification]) === null || _specificationCpuToRa2 === void 0 ? void 0 : _specificationCpuToRa2[cpu];
        if ((items === null || items === void 0 ? void 0 : items.length) > 0) {
          return {
            items: generateRamItems(items)
          };
        }
      }
    },
    systemDisk: getDisk({
      space: {
        accessorKey: "".concat(prefix, ".evs.systemDisk.diskSpace"),
        label: 'Объем системного диска',
        defaultValue: 480,
        uiProps: {
          min: 480,
          max: 1000
        }
      },
      specification: {
        accessorKey: "".concat(prefix, ".evs.systemDisk.specification")
      }
    }),
    additionalDisk: getDisk({
      space: {
        accessorKey: "".concat(prefix, ".evs.additionalDisk.diskSpace"),
        label: 'Объем дополнительного диска',
        defaultValue: 600,
        uiProps: {
          min: 600,
          max: 32000
        }
      },
      specification: {
        accessorKey: "".concat(prefix, ".evs.additionalDisk.specification")
      }
    }),
    additionalDiskCounter: {
      type: CONTROL.Stepper,
      decoratorProps: {
        label: 'Количество дополнительных дисков'
      },
      accessorKey: "".concat(prefix, ".evs.additionalDiskCounter"),
      defaultValue: 1,
      uiProps: {
        min: 1,
        max: 10,
        postfix: 'Шт',
        visible: false
      }
    },
    instanceCount: {
      type: CONTROL.Stepper,
      decoratorProps: {
        label: 'Количество Master Node'
      },
      accessorKey: "".concat(prefix, ".instanceCount"),
      defaultValue: 2,
      uiProps: {
        min: 2,
        max: 9,
        postfix: 'Шт'
      }
    }
  };
}
function getAlert(prefix, label) {
  return {
    type: CONTROL.Alert,
    uiProps: {
      description: "\u0414\u043B\u044F ".concat(label, " \u0431\u0443\u0434\u0435\u0442 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0430 \u0412\u0438\u0440\u0442\u0443\u0430\u043B\u044C\u043D\u0430\u044F \u043C\u0430\u0448\u0438\u043D\u0430 ECS \u0441 \u0430\u043D\u0430\u043B\u043E\u0433\u0438\u0447\u043D\u044B\u043C\u0438 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0430\u043C\u0438 \u043F\u043E \u0442\u0438\u043F\u0443 \u0441\u0435\u0440\u0432\u0435\u0440\u0430, vCPU, RAM \u0412\u0438\u0440\u0442\u0443\u0430\u043B\u044C\u043D\u0430\u044F \u043C\u0430\u0448\u0438\u043D\u0430: ECS General-Purpose 16vCPU 64 GB")
    },
    watchedControls: {
      specification: "".concat(prefix, ".mrs.specification"),
      cpu: "".concat(prefix, ".mrs.cpu"),
      ram: "".concat(prefix, ".mrs.ram")
    },
    relateFn: function relateFn(_ref3) {
      var specification = _ref3.specification,
        cpu = _ref3.cpu,
        ram = _ref3.ram;
      return {
        uiProps: {
          description: /*#__PURE__*/_jsxs(_Fragment, {
            children: ["\u0414\u043B\u044F ".concat(label, " \u0431\u0443\u0434\u0435\u0442 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0430 \u0412\u0438\u0440\u0442\u0443\u0430\u043B\u044C\u043D\u0430\u044F \u043C\u0430\u0448\u0438\u043D\u0430 ECS \u0441 \u0430\u043D\u0430\u043B\u043E\u0433\u0438\u0447\u043D\u044B\u043C\u0438 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0430\u043C\u0438 \u043F\u043E \u0442\u0438\u043F\u0443 \u0441\u0435\u0440\u0432\u0435\u0440\u0430, vCPU,\n            RAM"), /*#__PURE__*/_jsx("br", {}), "\u0412\u0438\u0440\u0442\u0443\u0430\u043B\u044C\u043D\u0430\u044F \u043C\u0430\u0448\u0438\u043D\u0430: ".concat(specification, " ").concat(cpu, "vCPU ").concat(ram, " GB")]
          })
        }
      };
    },
    accessorKey: 'vm-add'
  };
}
var masterNode = getNodeConfig('masterNode');
var workerNode = getNodeConfig('workerNode');
export var MAP_REDUCE_FORM_CONFIG = {
  ui: ['masterNode', 'workerNode'],
  controls: {
    masterNode: {
      type: CONTROL.Object,
      decoratorProps: {
        label: 'Master Node',
        labelTooltip: 'Мастер-нода (Master Node) предназначена для управления кластером и включает в себя виртуальную машину ECS, службу MRS для работы с большими данными на базе ClickHouse и диски EVS для выполнения вычислений'
      },
      ui: ['alert', 'specification', ['cpu', 'ram'], ['systemDisk', 'additionalDisk'], ['instanceCount']],
      controls: {
        alert: getAlert('masterNode', 'Master Node'),
        specification: _objectSpread(_objectSpread({}, masterNode.specification), {}, {
          items: masterNode.specification.items.slice(0, 3)
        }),
        cpu: masterNode.cpu,
        ram: masterNode.ram,
        systemDisk: masterNode.systemDisk,
        additionalDisk: masterNode.additionalDisk,
        instanceCount: masterNode.instanceCount,
        // Hidden
        additionalDiskCounter: masterNode.additionalDiskCounter
      }
    },
    workerNode: {
      type: CONTROL.Object,
      decoratorProps: {
        label: 'Worker Node',
        labelTooltip: 'Воркер-нода (Worker Node) предназначена для обработки и хранения данных и включает в себя виртуальную машину ECS, службу MRS для работы с большими данными на базе ClickHouse и диски EVS для выполнения вычислений'
      },
      ui: ['alert', 'specification', ['cpu', 'ram'], ['systemDisk', 'additionalDisk'], ['additionalDiskCounter', 'localDisk'], ['instanceCount']],
      controls: {
        alert: getAlert('workerNode', 'Worker Node'),
        specification: workerNode.specification,
        cpu: workerNode.cpu,
        ram: workerNode.ram,
        systemDisk: workerNode.systemDisk,
        additionalDisk: workerNode.additionalDisk,
        additionalDiskCounter: _objectSpread(_objectSpread({}, workerNode.additionalDiskCounter), {}, {
          uiProps: _objectSpread(_objectSpread({}, workerNode.additionalDiskCounter.uiProps), {}, {
            visible: true
          }),
          watchedControls: {
            workerNodeMrsSpecification: 'workerNode.mrs.specification'
          },
          relateFn: function relateFn(_ref4) {
            var workerNodeMrsSpecification = _ref4.workerNodeMrsSpecification;
            if (workerNodeMrsSpecification === MrsSpecificationItem.DiskIntensive) {
              return {
                uiProps: {
                  visible: false
                }
              };
            }
          }
        }),
        localDisk: {
          type: CONTROL.Object,
          ui: ['workerNodeEvsLocalDisk'],
          controls: {
            workerNodeEvsLocalDisk: getDisk({
              space: {
                accessorKey: 'workerNode.evs.localDisk.diskSpace',
                label: 'Объем локального диска',
                defaultValue: 29800,
                uiProps: {
                  min: 600,
                  max: 32000,
                  showHint: false,
                  disabled: true
                }
              },
              specification: {
                accessorKey: 'workerNode.evs.localDisk.specification',
                uiProps: {
                  disabled: true
                }
              }
            })
          },
          visible: false,
          watchedControls: {
            workerNodeMrsSpecification: 'workerNode.mrs.specification'
          },
          relateFn: function relateFn(_ref5) {
            var workerNodeMrsSpecification = _ref5.workerNodeMrsSpecification;
            if (workerNodeMrsSpecification === MrsSpecificationItem.DiskIntensive) {
              return {
                visible: true
              };
            }
          }
        },
        instanceCount: _objectSpread(_objectSpread({}, workerNode.instanceCount), {}, {
          decoratorProps: {
            label: 'Количество Worker Node'
          }
        })
      }
    }
  }
};